// extracted by mini-css-extract-plugin
export default {"scrollToSite":"XNxRcCfR","stick":"qrKXH6di","scrolled":"LXNezqMh","stickLink":"_5etr5ibN","body":"LjhdpfeD","title":"F7uS0Gr8","screenlink":"QofQRULR","overlay":"I8mwvmGG"};